var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cont_main[data-v-e7f1bea2]{background-image:url(" + escape(require("../assets/pictures/1.jpg")) + ");background-repeat:no-repeat;background-position:50%;background-size:cover;background-attachment:fixed}.me_logo[data-v-e7f1bea2]{background-image:url(" + escape(require("../assets/icons/me_text.svg")) + ");background-size:contain;color:transparent!important;background-color:transparent!important;background-repeat:no-repeat}.inputfile[data-v-e7f1bea2]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}#file_loader[data-v-e7f1bea2]{margin:0;padding:0;cursor:pointer}.border-danger[data-v-e7f1bea2]{border:3px solid #da4453!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7f1bea2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Login.vue
// module id = 271
// module chunks = 0